import React, { useState } from 'react';

export default function SpectatorJoinScreen({ onJoin, error, setError }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    setLoading(true);
    setError('');
    await onJoin(trimmed);
    setLoading(false);
  };

  return (
    <div className="join-screen">
      <div>
        <div className="game-title">Avalon</div>
        <div className="subtitle">Spectator View</div>
      </div>

      <div className="spectator-join-info">
        You are joining as a spectator. You will see all roles and game information.
        Enter your name so the moderator knows who is watching.
      </div>

      <form className="join-form" onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Your display name"
          value={name}
          onChange={e => { setName(e.target.value); setError(''); }}
          maxLength={20}
          autoFocus
          disabled={loading}
        />
        {error && <div className="error-msg">{error}</div>}
        <button
          type="submit"
          className="btn btn-gold btn-full"
          disabled={!name.trim() || loading}
        >
          {loading ? 'Joining...' : 'Watch Game'}
        </button>
      </form>
    </div>
  );
}
